import { createContext, useContext } from "react";

import type { AppLocale } from "@/lib/locale/resolve-effective-locale";

export type LocaleDebugContextValue = {
  override: AppLocale | null;
  setOverride: (locale: AppLocale | null) => void;
};

export const LocaleContext = createContext<AppLocale>("nl");

export const LocaleDebugContext = createContext<LocaleDebugContextValue | null>(null);

export function useLocale(): AppLocale {
  return useContext(LocaleContext);
}

export function useLocaleDebugControls(): LocaleDebugContextValue {
  const ctx = useContext(LocaleDebugContext);
  if (!ctx) {
    throw new Error("useLocaleDebugControls must be used within LocaleProvider");
  }
  return ctx;
}
